import React from 'react';

const Pay = () => {
    return (
        <div>
             <h3 className="pt-3 mt-5 text-center "><b>Payment System</b> <span className="text-primary"><b>Coming Soon</b></span></h3>
        </div>
    );
};

export default Pay;